import { useCurrentTenant } from "@drift/oneplatfront";
import { usePost, useAuth } from "@onefront/react-sdk";
import { generateHeaders } from "../../../utils/generate-headers";

interface IParamsFetch {
    params?: any;
    headers?: any;
    data: any;
    url?: string;
}

interface IusePostAdditionalBusinessDetails {
    (workspaceId?: string, businessId?: string, service?: string, params?: any | object, lazy?: boolean): {
        data?: any;
        loading?: boolean;
        fetch: (fetchConfig: IParamsFetch) => Promise<any>;
        error: boolean;
    };
}

export const usePostAdditionalBusinessDetails: IusePostAdditionalBusinessDetails = (
    workspaceId,
    businessId,
    service,
    params = {},
    lazy = true
) => {
    const { tenant } = useCurrentTenant(true);
    return usePost(
        `rnd:core:workspace-write:api://v1/workspaces/${workspaceId}/business/${businessId}/${service}`,
        {},
        {
            params: {
                ...params
            },
            headers: generateHeaders(useAuth(), tenant?.itemId, workspaceId),
            lazy
        }
    );
};
